import React, { forwardRef, useImperativeHandle } from 'react';

import * as General from '../General/General';
import * as rsuite from 'rsuite';
import { trackPromise } from 'react-promise-tracker';
import axios from 'axios';


const Auto_Product = forwardRef((props, ref) => {

    const [List, setList] = React.useState([]);

    useImperativeHandle(ref, () => ({

        Bind(groupParentId, groupId, title) {

            var RequestOptions = {
                data: {
                    'Title': title,
                    'ProductGroupId': groupId,
                    'ProductGroupParentId': groupParentId,
                },
                url: General.ApiRoute() + "/Product/SearchByGroup",
                method: "post",
                withCredentials: true,

                headers: {
                    'ApiKey': General.APIKey(),
                    'Content-Type': 'application/json'
                }
            }
            trackPromise(
                axios(RequestOptions)
                    .then(result => {
                        var tmp = []
                        for (var i = 0; i < result.data.length; i++) {
                            tmp.push({
                                Row: i + 1,
                                value: result.data[i].identityNo == 0 ?
                                    result.data[i].id + "|" + result.data[i].groupTitle + " - " + result.data[i].title + ' - ' + result.data[i].brandTitle :
                                    result.data[i].id + "|" + result.data[i].groupTitle + " - " + result.data[i].title + ' - ' + result.data[i].brandTitle + " (" + result.data[i].identityNo + ")",
                                lable: result.data[i].identityNo == 0 ?
                                    result.data[i].groupTitle + " - " + result.data[i].title + ' - ' + result.data[i].brandTitle :
                                    result.data[i].groupTitle + " - " + result.data[i].title + ' - ' + result.data[i].brandTitle + " (" + result.data[i].identityNo + ")",

                            })
                        }
                        setList(tmp)

                    })
                    .catch((error) => {
                        console.dir(error)
                    })
            )

        },
        focus() {
            const inputElement = document.querySelector('.FocusProductAutoComplete input');
            if (inputElement) {
                inputElement.focus();
            }
        }
    }),
        [props.value])

    return (
        <rsuite.AutoComplete
            data={List.map((product) => ({
                label: `${product.lable}`,
                value: `${product.value}`,
            }))}
            value={props.value}
            label={props.lable}
            onChange={(event) => props.onChange(event)}
            onSelect={(event) => props.onSelect(event)}
            // onKeyUp={(event) => props.onKeyUp(event)}

            className='FocusProductAutoComplete'
        />)
});

export default Auto_Product;